import { Component } from '@angular/core';

@Component({
  selector: 'app-grid-toggle',
  templateUrl: './grid-toggle.component.html',
  styleUrls: ['./grid-toggle.component.css']
})
export class GridToggleComponent {

  gridView = false;
  viewIcon = 'assets/images/gridview.png';
  viewTooltip = 'Toggle grid view';

  constructor() { }

  gridViewToggle() {
    this.gridView = !this.gridView;
    this.gridView ? this.viewIcon = 'assets/images/listview.png' : this.viewIcon = 'assets/images/gridview.png';
    this.gridView ? this.viewTooltip = 'Toggle list view' : this.viewTooltip = 'Toggle grid view';
  }

}
